export default function preventDefault(event: Event): void {
  // console.log('preventDefault', event.type, event)
  if (event) {
    event.preventDefault()
  }
}
